import React from 'react';
import { LoanNotesPage } from './pages/LoanNotesPage';
export function App() {
  return <LoanNotesPage data-id="element-0" />;
}